module.exports = __webpack_public_path__ + "img/u15.7cc8e7bc.png";